const options = {
    close: false,
    open: false
};
export default options;
